<template>
    <div class="row mb-7">
        <div class="col-xs-12">
            <ep-banner variant="warning">
                <!-- Single Entry Warning -->
                <span v-if="existingEntries.length === 1">
                    <!-- Client Booking Warning -->
                    <span v-if="entryType === 'booking'">
                        {{ trans('calendar.warning_appointment_1') }}
                        <span v-if="entryClient">
                            {{ trans('calendar.warning_with') }}
                            <strong>{{ entryClient }}</strong>
                        </span>
                        {{ trans('calendar.warning_appointment_2') }}
                    </span>

                    <!-- Event Warning -->
                    <span v-if="entryType === 'event'">
                        {{ trans('calendar.warning_event_1') }}
                        <strong>{{ existingEntries[0].name }}</strong>
                        {{ trans('calendar.warning_event_2') }}
                    </span>

                    <!-- Team Meeting Warning -->
                    <span v-if="entryType === 'team_meeting'">
                        {{ trans('apps.team_meetings.existing_entries_warning') }}
                        <strong>{{ existingEntries[0].name }}</strong>
                        {{ trans('calendar.warning_event_2') }}
                    </span>

                    <!-- Calendar Blocking Warning -->
                    <span v-if="entryType === 'calendar_block'">
                        {{ trans('calendar_blocking.calendar_blocking_create_warning', { calendar : entryName }) }}
                    </span>

                    <!-- Contact Booking Warning -->
                    <span v-if="entryType === 'contact_booking'">
                        {{ trans('calendar.warning_appointment_1') }}
                        <span v-if="entryContact">
                            {{ trans('calendar.warning_with') }}
                            <strong>{{ entryContact }}</strong>
                        </span>
                        {{ trans('calendar.warning_appointment_2') }}
                    </span>

                </span>

                <!-- Multiple Entries Warning -->
                <span v-if="existingEntries.length > 1">
                    {{ trans('calendar.warning_multi', { count : existingEntries.length }) }}
                </span>
            </ep-banner>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        existingEntries: {
            type: Array,
            default: () => []
        },
    },

    computed: {
        entryType() {
            return this.existingEntries[0].type;
        },

        entryName() {
            return this.existingEntries[0].name;
        },

        entryClient() {
            return this.existingEntries[0].client;
        },

        entryContact() {
            return this.existingEntries[0]?.contact;
        },
    },
}
</script>
